import React from 'react';
import Cookies from 'js-cookie';
import { Dropdown, Avatar, Grid } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { employeeName, userRole } from '../../GetRole.utils';
import './styles.css';

const ROLE_LABEL = { admin: 'Admin', bdTeam: 'Business development', finance: 'Finance' };

const initials = (name = '') =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

const handleLogOut = () => {
  Cookies.remove('token');
  window.location.href = process.env.REACT_APP_STAGING_URL;
};

const items = [
  {
    key: 'logout',
    icon: <LogoutOutlined />,
    label: 'Log out',
    onClick: handleLogOut,
  },
];

const User = () => {
  const screens = Grid.useBreakpoint();
  return (
    <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
      <button type="button" className="userTrigger" aria-label="Account menu">
        <Avatar style={{ background: '#E0E7FF', color: '#1E3EA0', fontWeight: 700 }}>
          {initials(employeeName)}
        </Avatar>
        {screens.md && (
          <span>
            <div className="userName">{employeeName}</div>
            <div className="userRole">{ROLE_LABEL[userRole] || ''}</div>
          </span>
        )}
      </button>
    </Dropdown>
  );
};

export default User;
